import type { ContactSuggestion } from '$contact-suggestions';

export const EMPTY_PLACEHOLDER_ID = 'no-options-found';

export const EMPTY_PLACEHOLDER_OPTION: ContactSuggestion = {
  userId: EMPTY_PLACEHOLDER_ID,
  googleId: '',
  followUpBossId: '',
  firstName: '',
  lastName: '',
  email: '',
  displayName: '',
  photoUrl: '',
  contactResponse: null,
  contactSource: null,
  group: '',
};
